export class Company {
  id: number;
  name: string;

  constructor(company: Company) {
    this.id = company.id;
    this.name = company.name;
  }
}
